import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";
import { FlexLayoutModule } from "@angular/flex-layout";

import { AteneaModule } from "@atenea-cms";
import { HomeSliderRoutes } from "./home-slider.routes";
import { HomeSliderFormComponent } from "./home-slider-form/home-slider-form.component";
import { HomeSliderSlideFormComponent } from "./home-slider-slide-form/home-slider-slide-form.component";
import { HomeSliderSlideActionFormComponent } from "./home-slider-slide-action-form/home-slider-slide-action-form.component";
import { HomeSliderService, HomeSliderFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    AteneaModule,
    HomeSliderRoutes,
  ],
  declarations: [
    HomeSliderFormComponent,
    HomeSliderSlideFormComponent,
    HomeSliderSlideActionFormComponent,
  ],
  providers: [HomeSliderService, HomeSliderFormService],
})
export class HomeSliderModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/home-slider.module.ts